import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase';
@Component({
  selector: 'app-auth-providers',
  templateUrl: './auth-providers.component.html',
  styleUrls: ['./auth-providers.component.css']
})
export class AuthProvidersComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }
  getProvider(provider) {
    switch (provider) {
      case "fb":
        return new firebase.auth.FacebookAuthProvider()
      case "g":
        return new firebase.auth.GoogleAuthProvider()
    }
  }
  signUpWith(provider) {
    let loginProvider = this.getProvider(provider);
    firebase.auth().signInWithPopup(loginProvider).then(res=>{
      const firecreds = provider.credential(res.idToken);
      firebase.auth().signInWithCredential(firecreds).then((success)=>{
        alert("auth1");
        return true;
      }).catch((err)=>{
        alert('Firebase auth failed ' + err);
    });
  }).catch((err)=>{
    alert('Error:' + err);
    return false;
    })
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/auth/register/auth-providers/auth-providers.component.ts